import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,{staticClass:"shadowCard"},[_c(VSubheader,[_vm._v("Resultado del TOEFL")]),_c(VCardText,[(_vm.verToefl)?_c(VTextarea,{attrs:{"readonly":"","auto-grow":""},model:{value:(_vm.mensaje),callback:function ($$v) {_vm.mensaje=$$v},expression:"mensaje"}}):_vm._e()],1)],1),(_vm.respuestaAlerta)?_c('Alerta',{attrs:{"parametros":_vm.parametros}}):_vm._e(),(_vm.cargar)?_c('Loader',{attrs:{"loader":_vm.loader}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }